import { Drawer } from "@components/ui/Drawer"
import { useFlyingCarpet } from "@features/flying-carpet/useFlyingCarpet"
import { RouteState, useRouter } from "eddev/routing"
import { usePresence } from "motion/react"
import { Suspense, useRef, useState } from "react"
import { ThemedRouteDisplay } from "./ThemedRouteDisplay"

export function RouteDrawer(props: { route: RouteState }) {
  const containerRef = useRef<HTMLDivElement>(null)
  const router = useRouter()
  const [closed, setClosed] = useState(false)
  const [isPresent, safeToRemove] = usePresence()

  const isOpen = isPresent && !closed

  return (
    <Suspense>
      <Drawer
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) {
            setClosed(true)
            if (router.getState()?.activeRoute === props.route) {
              setTimeout(() => {
                history.go(-1)
                safeToRemove?.()
              }, 600)
            }
          }
        }}
        dismissable={false}
        padded={false}
        handle
        className="route-drawer theme-light z-[44] route-drawer-fade-out border-t-none bg-transparent will-change-transform max-h-[calc(var(--visual-viewport-height,100dvh)-var(--spacing-headerHeight))] overscroll-none"
        classes={{
          overlay: "z-[30]",
          scroller: "rounded-t-[calc(min(24px,var(--snap-point-height)))] overscroll-none",
          handle: "absolute top-0 left-0 right-0 z-10 opacity-10",
        }}
        snapping
        onOverlayPointerDown={(e) => {
          setClosed(true)
        }}
      >
        <div ref={containerRef} className="fade-target will-change-transform">
          <Drawer.Title hidden></Drawer.Title>
          <Drawer.Description hidden></Drawer.Description>
          <ThemedRouteDisplay route={props.route} />
        </div>
      </Drawer>
    </Suspense>
  )
}
